import async from 'components/Async';
import PageRouteUtil from 'routes/util';
import { access } from 'constants/index';

const JobReportingPage = async(() => import('./JobReportingPage'));
const JobReportingPageV2 = async(() => import('./JobReportingPageV2'));
const OrganizationSettingsPage = async(() => import('./settings/OrganizationSettingsPage'));
const TargetCPASettingPage = async(() => import('./TargetCPASettingPage'));
const BillingSummaryPage = async(() => import('./Billing/BillingSummaryPage'));
const HiringCompanySettingsPage = async(() => import('./settings/HiringCompanySettingsPage'));
const JobGroupSettingsPage = async(() => import('./settings/JobGroupSettingsPage'));
const ManageJobPage = async(() => import('./ManageJobsPage'));
const ManageJobPageV2 = async(() => import('./ManageJobsPageV2'));
const ManageJobPageV2Beta = async(() => import('./ManageJobsPageV2Beta'));
const BillingDetailsPage = async(() => import('./Billing/BillingDetailsPage'));


const jobFeedRouteList = [
   {
      path: '/job-feed/job-reporting',
      component: JobReportingPageV2,
   },
   {
      path: '/job-feed/job-reporting-v1',
      component: JobReportingPage,
   },
   {
      path: '/job-feed/account-status',
      component: ManageJobPageV2Beta,
   },
   {
      path: '/job-feed/account-status-v1',
      component: ManageJobPage,
      access: access.byRole.partner.onlyAdmin,
   },
   {
      path: '/job-feed/account-status-v2-1',
      component: ManageJobPageV2,
      access: access.byRole.partner.onlyAdmin,
   },
   {
      path: '/job-feed/settings/target-cpa',
      component: TargetCPASettingPage,
      access: access.byRole.partner.onlyAdmin,
   },
   {
      path: '/job-feed/billing-summary/search',
      component: BillingSummaryPage,
      access: access.byRole.partner.onlyAdmin,
   },
   {
      path: '/job-feed/settings/organization',
      component: OrganizationSettingsPage,
      access: access.getAdminAccessByApp.jobFeed,
   },
   {
      path: '/job-feed/settings/hiring-company',
      component: HiringCompanySettingsPage,
   },
   {
      path: '/job-feed/settings/job-group',
      component: JobGroupSettingsPage,
   },
   {
      path: '/job-feed/billing/details',
      component: BillingDetailsPage,
   },
];

export default PageRouteUtil.getPageRouteListHavingDefaultProperties(jobFeedRouteList);
